// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ful-dash-page {
  background-color: #071414;
  min-height: 100vh;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
}

.ful-dash-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}


.ful-tabs {
  display: flex;
  gap: 8px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 4px;
  border-radius: 12px;
  width: fit-content;
}

.ful-tab-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ful-tab-btn:hover {
  color: #ffffff;
}

.ful-tab-btn.active {
  background: #3bb3ae;
  color: #071414;
  box-shadow: 0 4px 12px rgba(59, 179, 174, 0.2);
}

.ful-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.ful-card {
  background: rgba(14, 27, 27, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  transition: all 0.25s ease;
  backdrop-filter: blur(10px);
}

.ful-card:hover {
  border-color: rgba(72, 209, 204, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
}

.ful-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding-bottom: 12px;
}

.ful-card__booking-id {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  font-family: monospace;
}

.ful-card__customer {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin: 4px 0 0 0;
}

.ful-card-body {
  display: flex;
  gap: 12px;
}

.ful-card__img-box {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ful-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ful-card__placeholder {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.2);
}

.ful-card-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}

.ful-card__prod-name {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ful-card__qty {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.ful-card__date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.ful-badge-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.ful-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 14px;
  margin-top: auto;
}

.ful-card__btn {
  background-color: #3bb3ae;
  color: #071414;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ful-card__btn:hover {
  background-color: #48d1cc;
  box-shadow: 0 4px 10px rgba(72, 209, 204, 0.2);
}

.ful-card__tracking-details {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Dispatch Modal Styles */
.ful-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

.ful-modal {
  background: #0e1b1b;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 460px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  animation: scaleUp 0.25s ease;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleUp {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.ful-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.ful-modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ful-modal-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ful-modal-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
}

.ful-modal-input,
.ful-modal-select,
.ful-modal-textarea {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: #ffffff;
  padding: 10px 14px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
}

.ful-modal-input:focus,
.ful-modal-select:focus,
.ful-modal-textarea:focus {
  border-color: #3bb3ae;
  outline: none;
}

.ful-modal-textarea {
  resize: vertical;
  min-height: 80px;
}

.ful-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

.ful-modal-btn-cancel {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ful-modal-btn-confirm {
  background-color: #3bb3ae;
  color: #071414;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ful-modal-btn-confirm:hover {
  background-color: #48d1cc;
}

.ful-empty-state {
  text-align: center;
  padding: 80px 40px;
  background: rgba(14, 27, 27, 0.4);
  border: 1px dashed rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  margin-top: 10px;
}

.ful-empty-icon {
  font-size: 40px;
  margin-bottom: 12px;
  opacity: 0.3;
}

.ful-empty-text {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.4);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/FulfillmentDashboardPage/FulfillmentDashboardPage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,qCAAqC;EACrC,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;;EAGE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX","sourcesContent":[".ful-dash-page {\n  background-color: #071414;\n  min-height: 100vh;\n  color: #ffffff;\n  font-family: 'Inter', sans-serif;\n}\n\n.ful-dash-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n\n.ful-tabs {\n  display: flex;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 4px;\n  border-radius: 12px;\n  width: fit-content;\n}\n\n.ful-tab-btn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ful-tab-btn:hover {\n  color: #ffffff;\n}\n\n.ful-tab-btn.active {\n  background: #3bb3ae;\n  color: #071414;\n  box-shadow: 0 4px 12px rgba(59, 179, 174, 0.2);\n}\n\n.ful-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.ful-card {\n  background: rgba(14, 27, 27, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 16px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n  transition: all 0.25s ease;\n  backdrop-filter: blur(10px);\n}\n\n.ful-card:hover {\n  border-color: rgba(72, 209, 204, 0.25);\n  transform: translateY(-2px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);\n}\n\n.ful-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  padding-bottom: 12px;\n}\n\n.ful-card__booking-id {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.35);\n  font-family: monospace;\n}\n\n.ful-card__customer {\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 4px 0 0 0;\n}\n\n.ful-card-body {\n  display: flex;\n  gap: 12px;\n}\n\n.ful-card__img-box {\n  width: 64px;\n  height: 64px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ful-card__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ful-card__placeholder {\n  font-size: 20px;\n  color: rgba(255, 255, 255, 0.2);\n}\n\n.ful-card-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow: hidden;\n}\n\n.ful-card__prod-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ful-card__qty {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0;\n}\n\n.ful-card__date {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0;\n}\n\n.ful-badge-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.ful-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  padding-top: 14px;\n  margin-top: auto;\n}\n\n.ful-card__btn {\n  background-color: #3bb3ae;\n  color: #071414;\n  border: none;\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ful-card__btn:hover {\n  background-color: #48d1cc;\n  box-shadow: 0 4px 10px rgba(72, 209, 204, 0.2);\n}\n\n.ful-card__tracking-details {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.45);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n/* Dispatch Modal Styles */\n.ful-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(5px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease;\n}\n\n.ful-modal {\n  background: #0e1b1b;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 24px;\n  width: 100%;\n  max-width: 460px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  animation: scaleUp 0.25s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes scaleUp {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.ful-modal-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.ful-modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ful-modal-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ful-modal-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.ful-modal-input,\n.ful-modal-select,\n.ful-modal-textarea {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  color: #ffffff;\n  padding: 10px 14px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n}\n\n.ful-modal-input:focus,\n.ful-modal-select:focus,\n.ful-modal-textarea:focus {\n  border-color: #3bb3ae;\n  outline: none;\n}\n\n.ful-modal-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.ful-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.ful-modal-btn-cancel {\n  background: none;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ful-modal-btn-confirm {\n  background-color: #3bb3ae;\n  color: #071414;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.ful-modal-btn-confirm:hover {\n  background-color: #48d1cc;\n}\n\n.ful-empty-state {\n  text-align: center;\n  padding: 80px 40px;\n  background: rgba(14, 27, 27, 0.4);\n  border: 1px dashed rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  margin-top: 10px;\n}\n\n.ful-empty-icon {\n  font-size: 40px;\n  margin-bottom: 12px;\n  opacity: 0.3;\n}\n\n.ful-empty-text {\n  font-size: 15px;\n  color: rgba(255, 255, 255, 0.4);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
